import React, { useEffect, useMemo, useState } from "react";
import CryptoJS from "crypto-js";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import moment from "moment";
import { withStyles } from "@material-ui/styles";
import {
  Badge,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Container,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputBase,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  makeStyles,
} from "@material-ui/core";
import { CancelRounded, Info, ShoppingCart } from "@material-ui/icons";
import MuiAlert from "@material-ui/lab/Alert";
import Text from "../Text/Text";
import { Stepper } from "../Stepper/Stepper";
import { Step } from "../Stepper/Step";
import { StepperControlFooter } from "../Stepper/StepperControlFooter";
import { useStepper } from "../Stepper/hooks";
import TextInput from "../TextInput/TextInput";
import CreditCardText from "../TextInput/CreditCardText";
import TextInputWithMasking from "../TextInput/TextInputWithMasking";
import PermitContent from "./PermitContent";
import BuyPerimtsEditOrderModal from "../Modals/buypermits/BuyPermitsExitOrderModal";
import {
  getBuyCheckCreditCradDetails,
  getBuyPermitAcceptedPaymentMethods,
  getBuyPermitOrderPayment,
  hideBuyPermitsExitOrderModal,
  hideBuyPermitThankYouModal,
  hideCheckoutSelectAddressModal,
  hideCheckoutSelectBillingAddressModal,
  hideCheckoutSelectEmailModal,
  hideCheckoutSelectPhoneModal,
  showBuyPermitsExitOrderModal,
  showCheckoutSelectAddressModal,
  showCheckoutSelectEmailModal,
  showCheckoutSelectPhoneModal,
} from "store/buyPermits/action";
import { RouteService } from "services/route.service";
import { getUserContextData } from "store/login/selector";
import SelectAddressModal from "../Modals/buypermits/SelectAddressModal";
import AddAddressModal from "../Modals/profile/AddAddressModal";
import AddEmailModal from "../Modals/profile/AddEmailModal";
import AddPhoneNumberModal from "../Modals/profile/AddPhoneNumberModal";
import {
  hideProfileDriverAddressModal,
  hideProfileDriverEmailModal,
  hideProfileDriverPhoneModal,
  showProfileDriverAddressModal,
  showProfileDriverEmailModal,
  showProfileDriverPhoneModal,
} from "store/profile/action";
import SelectPhoneModal from "../Modals/buypermits/SelectPhoneModal";
import SelectEmailModal from "../Modals/buypermits/SelectEmailModal";
import SelectBillingAddressModal from "../Modals/buypermits/SelectBillingAddressModal";
import {
  getAccountDriverBillingAddress,
  getPaymentPageEditorSelector,
  getProfileData,
  getStatesSelector,
} from "store/profile/selector";
import TermAndCondition from "../Modals/TermAndCondition";
import { hideTermAndCondition, showTermAndCondition } from "store/login/action";
import SelectCreditCardInformationModal from "../Modals/buypermits/SelectCreditCardInformationModal";
import { getDriverPermitListStates } from "store/permitList/action";
import { getDriverViewOrderStates } from "store/vieworder/action";
import { getCardTypeVisitorPermit } from "store/visitorPermit/action";
import AddBillingAdressModal from "../Modals/profile/AddBillingAdressModal";
import PermitPaymentStatus from 'components/Pages/PermitPaymentStatus';

import VISA from "../../assets/image/VISA.png";
import "./page.css";

const useStyles = makeStyles((theme) => ({
  p5: {
    padding: "5px",
  },
  root: {
    minHeight: "calc(100vh - 302px)", width: "100%",
  },
  rightGrid: {
    justifyContent: "center", alignItems: "center",
  },
  toolbarContainer: {
    marginBottom: "10px", position: "relative", padding: "10px",
  },
  rightIconsContainer: {
    position: "absolute", right: "20px", top: 0,
  },
  alignBase: {
    alignItems: "baseline",
  },
  fGap: {
    gap: "10px",
  },
  vehicleCardHeader: {
    background: theme.palette.primary.main, color: "white",
  },
  vehiclesUl: {
    listStyleType: "none", padding: 0, margin: 0, fontSize: "11px",
  },
  thirdStepFirstDivChild: {
    background: theme.palette.primary.main, padding: "4px",
  },
  firstStepFirstChild: {
    background: theme.palette.primary.main, padding: "4px", width: "125px", color: "white",
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "gray !important",
    },
  },
  alignCenter: {
    alignItems: "center",
  },
  textField: {
    width: "100%",
    "& div": {
      padding: "7px 12px 10px",
    },
  },
  spaceTop: {
    marginTop: 25,
  },
  img: {
    width: 60,
  },
  link: {
    cursor: "pointer",
  },
  stateText: {
    paddingBottom: 8,
  },
  borderBottom: {
    borderBottom: "1px solid #a39b9b",
  },
  checkoutgrid: {
    position: "absolute", right: "10px",
  },
  checkoutvechile: {
    fontWeight: "600", fontSize: "15px", display: "flex", lineHeight: "20px", marginBottom: "12px",
  },
  checkoutfirstStepFirstChild: {
    background: theme.palette.primary.main, padding: "4px", width: "auto", color: "white", textAlign: "center",
  },
  checkoutdflex: {
    display: "flex",
  },
  checkoutdflextable: {
    display: "flex",
  },
  checkoutml: {
    marginLeft: "20px",
  },
  checkoutsubmit: {
    top: "258px", width: "400px", color: "white", backgroundColor: theme.palette.primary.main,
  },
  checkoutchangedflex: {
    display: "flex", justifyContent: "space-between",
  },
  checkoutTermandCondition: {
    color: "black", marginTop: "20px",
  },
  backgroundtheme: {
    color: theme.palette.primary.main,
  },
  checkoutinstruction: {
    marginTop: "3%",
  },
  summaryItems: {
    padding: "20px 56px 16px",
    [theme.breakpoints.down("xs")]: {
      padding: "16px 24px",
    },
  },
  summaryRow: {
    display: "flex", justifyContent: "space-between", alignItems: "center",
    fontSize: "17px", color: "black", padding: "5px 0",
  },
  summaryLabel: {
    display: "flex", alignItems: "center", gap: "8px",
  },
  summaryInfoIcon: {
    color: theme.palette.primary.main, fontSize: "22px", cursor: "pointer",
  },
  summaryTotalRow: {
    display: "flex", justifyContent: "space-between", alignItems: "center",
    fontSize: "20px", fontWeight: "bold", color: "black", padding: "24px 56px",
    [theme.breakpoints.down("xs")]: {
      padding: "20px 24px",
    },
  },
}));

const CheckoutPermit = (props) => {
  const history = useHistory();
  const classes = useStyles();
  const { StylingItem, handletoggleAddPermitPage, setCheckout } = props;
  useSelector((state) => state?.citationDetailState);
  const usStates = useSelector(getStatesSelector);
  const endUserAccountEntity = useSelector((state) => state?.profileState?.profileStateList?.endUserAccountEntity);
  const errorsMessage = useSelector((state) => state?.exitOrderReducer?.buyPemitCheckCreditCradDetails?.name)
  const [verifyModal, setVerifyModal] = useState(false);
  const id = endUserAccountEntity && endUserAccountEntity?.id;
  const dispatch = useDispatch();
  const [shippingCheckbox, setShippingCheckbox] = useState(false);
  const [submitOrder, setSubmitOrder] = useState(false);
  const [stepper, next, back, handleBack] = useStepper({ steps: 3 });
  const [checkNo, setCheckNo] = useState();
  const [state, setState] = useState({});
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [termAndConditionsAccepted, setTermAndConditionsAccepted] = useState(false);
  const profileStore = useSelector(getProfileData);
  const [openBillingModal, setOpenBillingModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const user = useSelector(getUserContextData);
  const merchantName = useSelector((state) => state?.exitOrderReducer?.buyPemitCheckCreditCradDetails?.name)
  const paymentProcessorType = useSelector((state) => state?.exitOrderReducer?.buyPemitCheckCreditCradDetails?.processorType)

  /** get profile data from reducer  */
  const BillingAddress = useSelector(getAccountDriverBillingAddress)
  const getBuyPermitsExitOrderModal = useSelector((state) => state?.exitOrderReducer?.buyPermitsExitOrderModal);
  const [isOpenExitOrderModal, setExitOrderModal] = useState(getBuyPermitsExitOrderModal);
  const isOpenAddAddressModal = useSelector((state) => state.profileState.profileDriverAddressModalState);
  const isOpenAddEmailModal = useSelector((state) => state.profileState.profileDriverEmailModalState);
  const isOpenAddPhoneModal = useSelector((state) => state.profileState.profileDriverPhoneModalState);
  const getCheckoutSelectAddressModal = useSelector((state) => state?.exitOrderReducer?.checkoutSelectAddressModal);
  const getCheckoutSelectAddressStateData = useSelector((state) => state?.exitOrderReducer?.checkoutSelectAddressState);
  const getCheckoutSelectBillingAddressModal = useSelector((state) => state?.exitOrderReducer?.checkoutSelectBillingAddressModal);
  const getCheckoutSelectEmailModal = useSelector((state) => state?.exitOrderReducer?.checkoutSelectEmailModal);
  const getCheckoutSelectEmailStateData = useSelector((state) => state?.exitOrderReducer?.checkoutSelectEmailState);
  const getCheckoutSelectPhoneModal = useSelector((state) => state?.exitOrderReducer?.checkoutSelectPhoneModal);
  const getCheckoutSelectPhoneStateData = useSelector((state) => state?.exitOrderReducer?.checkoutSelectPhoneState);
  const [isOpenSelectAddressModal, setIsOpenSelectAddressModal] = useState(getCheckoutSelectAddressModal);
  const [isOpenSelectBillingAddressModal, setIsOpenSelectBillingAddressModal] = useState(getCheckoutSelectBillingAddressModal);
  const [isOpenSelectPhoneModal, setIsOpenSelectPhoneModal] = useState(getCheckoutSelectPhoneModal);
  const [isOpenSelectEmailModal, setIsOpenSelectEmailModal] = useState(getCheckoutSelectEmailModal);
  const checkoutSelectedAddress = useSelector((state) => state?.exitOrderReducer?.checkoutSelectedAddress);
  const checkoutSelectedBillingAddress = useSelector((state) => state?.exitOrderReducer?.checkoutSelectedBillingAddress);
  const checkoutSelectedEmail = useSelector((state) => state?.exitOrderReducer?.checkoutSelectedEmail);
  const checkoutSelectedPhone = useSelector((state) => state?.exitOrderReducer?.checkoutSelectedPhone);
  const getBuyPermitSelectedPermitsState = useSelector((state) => state?.exitOrderReducer?.buyPermitSelectedPermits);
  const isOpenThankYouModal = useSelector((state) => state?.exitOrderReducer?.buyPermitThankYouModalState);
  const paymentMethodState = useSelector((state) => state?.exitOrderReducer?.buyPermitPaymentMethods);

  const acceptedPaymentMethodsState = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitAcceptedPaymentMethods
  );
  const acceptedPaymentMethods = useMemo(
    () => acceptedPaymentMethodsState ?? [],
    [acceptedPaymentMethodsState]
  );
  const PaymentPageEditorData = useSelector(getPaymentPageEditorSelector);
  const [PaymentPageEditorDataState, setPaymentPageEditorDataState] = useState();
  const [cardInfo, setCardInfo] = useState(false);

  const permitTaxRatePrice = useSelector((state) => state?.exitOrderReducer?.buyPermitTaxRatePrice);
  const endUserId = useSelector((state) => state?.profileState?.profileStateList?.endUserAccountEntity?.id);

  const [address, setAddress] = useState();
  const [email, setEmail] = useState();
  const [phone, setPhone] = useState();
  const [permit, setPermit] = useState([]);

  const paymentMethodOptions = [...new Set(paymentMethodList || [])];

  useEffect(() => {
    if (state.cvv && state.credit && state.expireDate && state.cardHolderName && state.error === '') {
      setCardInfo(true)
    } else {
      setCardInfo(false)
    }
  }, [state]);

  useEffect(() => {
    dispatch(getCardTypeVisitorPermit(user?.user?.userGroup));
    setPaymentPageEditorDataState(PaymentPageEditorData);
  }, [PaymentPageEditorData]);

  useEffect(() => {
    if (getBuyPermitSelectedPermitsState) {
      setPermit(getBuyPermitSelectedPermitsState);
    }
  }, [getBuyPermitSelectedPermitsState]);

  useEffect(() => {
    if (user) {
      dispatch(getBuyCheckCreditCradDetails(user?.user?.userGroup));
      dispatch(getBuyPermitAcceptedPaymentMethods(user?.user?.userGroup));
    }
  }, [user]);

  // Drop a selection that is no longer accepted, in case the catalog lands after the driver picked.
  useEffect(() => {
    if (paymentMethod && acceptedPaymentMethods.length && !acceptedPaymentMethods.includes(paymentMethod)) {
      setPaymentMethod("");
    }
  }, [acceptedPaymentMethods, paymentMethod]);

  useEffect(() => {
    setSubmitOrder(isOpenThankYouModal);
  }, [isOpenThankYouModal]);

  useEffect(() => {
    const extractPaymentMethods = (paymentMethodState) => {
      if (!Array.isArray(paymentMethodState)) return [];

      const methods = paymentMethodState.flatMap((item) => {
        switch (item.ruleType) {
          case 'ALLOWED_PMT_METHODS':
            return item.ruleValues || [];
          case 'PMT_METHOD_NOCHARGE':
            return ['NO_CHARGE'];
          case 'PMT_METHOD_TUITION':
            return ['DRIVER_ACCOUNT'];
          case 'PMT_METHOD_PAYROLL':
            return ['PAYROLL_DEDUCTION'];
          default:
            return [];
        }
      });

      return [...new Set(methods)];
    }

    const paymentMethods = extractPaymentMethods(paymentMethodState);
    setPaymentMethodList(paymentMethods);
  }, [paymentMethodState]);

  ////////// Select address Modal ////////////
  const closeSelectAddressModal = () => {
    dispatch(hideCheckoutSelectAddressModal(false));
  };

  const openSelectAddressModal = () => {
    dispatch(showCheckoutSelectAddressModal(true));
  };

  const closeSelectBillingAddressModal = () => {
    dispatch(hideCheckoutSelectBillingAddressModal(false));
  };

  const openSelectBillingAddressModal = () => {
    setOpenBillingModal(true)
  };

  useEffect(() => {
    setIsOpenSelectAddressModal(getCheckoutSelectAddressModal);
    setIsOpenSelectBillingAddressModal(getCheckoutSelectBillingAddressModal);
    setIsOpenSelectPhoneModal(getCheckoutSelectPhoneModal);
    setIsOpenSelectEmailModal(getCheckoutSelectEmailModal);
  }, [
    getCheckoutSelectAddressModal,
    getCheckoutSelectBillingAddressModal,
    getCheckoutSelectPhoneModal,
    getCheckoutSelectEmailModal,
    getCheckoutSelectAddressStateData,
    getCheckoutSelectEmailStateData,
    getCheckoutSelectPhoneStateData
  ]);

  useEffect(() => {
    setAddress(Array.isArray(getCheckoutSelectAddressStateData) && getCheckoutSelectAddressStateData.filter((ele) => {
      if (ele.defaultFlag === true) {
        return ele;
      }
    }));

    setEmail(Array.isArray(getCheckoutSelectEmailStateData) && getCheckoutSelectEmailStateData.filter((ele) => {
      if (ele.defaultFlag === true) {
        return ele;
      }
    }));

    setPhone(Array.isArray(getCheckoutSelectPhoneStateData) && getCheckoutSelectPhoneStateData.filter((ele) => {
      if (ele.defaultFlag === true) {
        return ele;
      }
    }));
  }, [
    getCheckoutSelectPhoneStateData,
    getCheckoutSelectAddressStateData,
    getCheckoutSelectEmailStateData,
    checkoutSelectedAddress,
    checkoutSelectedEmail,
    checkoutSelectedPhone
  ]);

  useEffect(() => {
    setExitOrderModal(getBuyPermitsExitOrderModal);
  }, [getBuyPermitsExitOrderModal]);

  const goToAnotherPermit = () => {
    dispatch(getDriverPermitListStates(profileStore && profileStore?.accountId))
    dispatch(getDriverViewOrderStates(endUserId))
    dispatch(hideBuyPermitThankYouModal());
    handletoggleAddPermitPage("Add");
  };

  const validSelectDate = (pusData, validDate, allData, endDate) => {
    if (allData?.permit?.permitType === "STD_PERMIT") {
      return moment(allData?.permit?.validEndDate)?.format("MM/DD/YYYY")
    } else if (pusData && allData?.permit?.permitType === "EFP") {
      var isafter = moment(pusData).add(validDate, 'days').isAfter(endDate);
      if (isafter === true) {
        return moment(allData?.permit?.validEndDate)?.format("MM/DD/YYYY")
      } else {
        return moment(pusData).add(validDate, 'days')?.format("MM/DD/YYYY")
      }
    }
  }

  const validSelectDatePayload = (pusData, validDate, allData, endDate) => {
    if (allData?.permit?.permitType === "STD_PERMIT") {
      return (allData?.permit?.validEndDate)
    } else if (pusData && allData?.permit?.permitType === "EFP") {
      var isafter = moment(pusData).add(validDate, 'days').isAfter(endDate);
      if (isafter === true) {
        return (allData?.permit?.validEndDate)
      } else {
        return moment(pusData).add(validDate, 'days')
      }
    }
  }

  let creditCardNumber = state?.credit;
  const creditCardformate = creditCardNumber?.replace(/\s/g, '');
  const key = 'mySecretKey';
  const encryptedCardInfo = encryptCreditCardInfo(state, key);

  function encryptCreditCardInfo(state, key) {
    const encryptedCardName = CryptoJS?.AES?.encrypt(state?.cardHolderName, key);
    const encryptedCardNumber = CryptoJS?.AES?.encrypt(creditCardformate, key);
    const encryptedCVV = CryptoJS?.AES?.encrypt(state?.cvv, key);
    return {
      cardHolderName: encryptedCardName?.toString(),
      cardNumber: encryptedCardNumber?.toString(),
      cvv: encryptedCVV?.toString(),
    };
  }

  const stylingVal = {
    backgroundColor: StylingItem && StylingItem.bodyColor,
    fontFamily: StylingItem && StylingItem.font,
    color: StylingItem && StylingItem.fontColor,
  };

  const handleNext = () => () => {
    if (stepper.current === 1 && paymentMethod !== "") {
      if (paymentMethodList === 'NO_CHARGE') {
        setVerifyModal(false)
        next(stepper.current);
      } else {
        if (paymentMethod === "ONLINE_CC" && stepper.current === 1 && (errorsMessage && errorsMessage?.errorMessage) === "Credit card payments are not allowed. Please go back and select a different payment method. ") {
          setVerifyModal(true)
          handleBack(1);
        } else {
          next(stepper.current);
        }
      }
    } else {
      next(stepper.current);
    }
  };

  const handleCreditCardChange = () => {
    handleBack(1);
  };

  const handleBillingChange = () => {
    handleBack(0);
  };

  const handleChange = (e) => {
    setState({
      ...state, [e.target.name]: e.target.value,
    });
  };

  const handleChanges = (e) => {
    const { name, value } = e.target;
    const newState = { ...state, [name]: value };

    if (name === "credit" && value.length !== 18 && value.length !== 19) {
      newState.error = "Credit card number must be 15 or 16 characters long";
    } else {
      newState.error = ""; // Clear the error if the length is correct
    }

    setState(newState);
  };

  const totalPrice = permit?.reduce((sum, item) => sum + (item?.permit?.price || 0), 0) || 0;
  const totalFee = permit?.reduce((sum, item) => sum + (item?.permit?.fee || 0), 0) || 0;
  const tax = (permitTaxRatePrice?.taxRate * totalPrice) / 100 || 0.00;
  const creditCardConvenienceFee = paymentMethod === "ONLINE_CC"
    ? (permit?.reduce((sum, item) => (
      item?.permit?.creditCardFeeEnabled && item?.permit?.creditCardFeeAmount
        ? sum + item.permit.creditCardFeeAmount
        : sum
    ), 0) || 0)
    : 0;
  const grassTotal = totalPrice + totalFee + tax + creditCardConvenienceFee;
  //////////End select address Modal////////////

  //////////select Phone Modal////////////
  const closeSelectPhoneModal = () => {
    dispatch(hideCheckoutSelectPhoneModal(false));
  };

  const openSelectPhoneModal = () => {
    dispatch(showCheckoutSelectPhoneModal(false));
  };
  //////////End select Phone Modal////////////

  //////////select Email Modal////////////
  const closeSelectEmailModal = () => {
    dispatch(hideCheckoutSelectEmailModal(false));
  };

  const openSelectEmailModal = () => {
    dispatch(showCheckoutSelectEmailModal(false));
  };
  //////////End select Email Modal////////////

  //////////Cancel Exit Modal////////////
  const cancelShowBuyPermitsExitOrderModal = () => {
    dispatch(showBuyPermitsExitOrderModal());
  };

  const CancelBuyPermitsExitOrderModal = () => {
    dispatch(hideBuyPermitsExitOrderModal());
  };

  const ConfirmBuyPermitsExitOrderModal = () => {
    history.push(RouteService.buyPermits);
    dispatch(hideBuyPermitsExitOrderModal());
  };
  //////////End Cancel Exit Modal////////////

  const goToCartModal = () => {
    setCheckout(false);
    handletoggleAddPermitPage("view");
  };

  const handleOpenAddAddressModal = () => {
    dispatch(showProfileDriverAddressModal());
  };

  const handleCloseAddAddressModal = () => {
    dispatch(hideProfileDriverAddressModal());
  };

  const handleOpenAddPhoneModal = () => {
    dispatch(showProfileDriverPhoneModal());
  };

  const handleCloseAddPhoneModal = () => {
    dispatch(hideProfileDriverPhoneModal());
  };

  const handleOpenAddEmailModal = () => {
    dispatch(showProfileDriverEmailModal());
  };

  const handleCloseAddEmailModal = () => {
    dispatch(hideProfileDriverEmailModal());
  };

  const userStateCode = (checkoutSelectedAddress && checkoutSelectedAddress?.state?.code) || (Array.isArray(address) && address[0]?.state?.code);

  const userState = usStates.filter((uState) => {
    return uState?.code === userStateCode;
  });

  const userStateCodes = (BillingAddress && BillingAddress?.values?.state)

  const userStates = usStates.filter((uState) => {
    return uState?.code === userStateCodes;
  });

  let splitable = state?.expireDate?.split("/");

  const handleSubmit = (e, tAmount) => {
    let permitData = [];
    let payObj = {};

    if (paymentMethod === "CHECK") {
      permitData = permit?.map((pmt) => {
        return {
          allowAnonymousSales: pmt?.permit?.allowAnonymousSales,
          allowedNoVehicles: pmt?.permit?.allowedNoVehicles,
          fee: pmt?.permit?.fee,
          hasFulfillmentLetter: pmt?.permit?.hasFulfillmentLetter,
          id: pmt?.permit?.id,
          lotName: pmt?.permit?.lotName,
          name: pmt?.permit?.name,
          permitType: pmt?.permit?.permitType,
          price: pmt?.permit?.price,
          validEndDate: validSelectDatePayload(pmt?.permit?.tdate, pmt?.permit?.validDays, pmt, pmt?.permit?.validEndDate),
          validStartDate: pmt?.permit?.permitType === "STD_PERMIT" ? pmt?.permit?.validStartDate : pmt?.permit?.tdate,
          vehicleIds: pmt?.vehicles?.map((vcl) => {
            return vcl.id;
          }),
        };
      });

      payObj = {
        groupName: user?.user?.userGroup,
        confirmationEmailId: (checkoutSelectedEmail && checkoutSelectedEmail?.id) || (Array.isArray(email) && email[0]?.id),
        fulfillmentAddressId: (checkoutSelectedAddress && checkoutSelectedAddress?.id) || (Array.isArray(address) && address[0]?.id),
        fulfillmentEmailId: (checkoutSelectedEmail && checkoutSelectedEmail?.id) || (Array.isArray(email) && email[0]?.id),
        paymentRequest: {
          acceptedAmount: tAmount, checkNumber: checkNo, note: "pay by check", paymentMethod: "CHECK",
        },
        permitsToPurchase: permitData,
        taxAmount: tax,
        totalAmount: tAmount,
        userAccountId: id,
      };
    } else if (paymentMethod === "ONLINE_CC" || paymentMethod === "") {
      if (totalFeePrice[0] === 0) {
        permitData = permit?.map((pmt) => {
          return {
            permitType: pmt?.permit?.permitType,
            validEndDate: validSelectDatePayload(pmt?.permit?.tdate, pmt?.permit?.validDays, pmt, pmt?.permit?.validEndDate),
            price: pmt?.permit?.price,
            name: pmt?.permit?.name,
            efpVisitReason: pmt?.reasonForVisit || "",
            allowedNoVehicles: pmt?.permit?.allowedNoVehicles,
            vehicleIds: pmt?.vehicles?.map((vcl) => {
              return vcl.id;
            }),
            validStartDate: pmt?.permit?.permitType === "STD_PERMIT" ? pmt?.permit?.validStartDate : pmt?.permit?.tdate,
            fee: pmt?.permit?.fee,
            hasFulfillmentLetter: pmt?.permit?.hasFulfillmentLetter,
            lotName: pmt?.permit?.lotName,
            allowAnonymousSales: pmt?.permit?.allowAnonymousSales,
            id: pmt?.permit?.id,
            efpStartDate: pmt?.permit?.validStartDate,
          };
        });

        payObj = {
          groupName: user?.user?.userGroup,
          userAccountId: id,
          totalAmount: tAmount,
          fulfillmentAddressId: (checkoutSelectedAddress && checkoutSelectedAddress?.id) || (Array.isArray(address) && address[0]?.id),
          permitsToPurchase: permitData,
          confirmationEmailId: (checkoutSelectedEmail && checkoutSelectedEmail?.id) || (Array.isArray(email) && email[0]?.id),
          fulfillmentEmailId: (checkoutSelectedEmail && checkoutSelectedEmail?.id) || (Array.isArray(email) && email[0]?.id),
          paymentRequest: {
            paymentMethod: "NO_CHARGE"
          },
          taxAmount: tax,
        };
      } else {
        permitData = permit?.map((pmt) => {
          return {
            permitType: pmt?.permit?.permitType,
            validEndDate: validSelectDatePayload(pmt?.permit?.tdate, pmt?.permit?.validDays, pmt, pmt?.permit?.validEndDate),
            price: pmt?.permit?.price,
            name: pmt?.permit?.name,
            efpVisitReason: pmt?.reasonForVisit || "",
            allowedNoVehicles: pmt?.permit?.allowedNoVehicles,
            vehicleIds: pmt?.vehicles?.map((vcl) => {
              return vcl.id;
            }),
            validStartDate: pmt?.permit?.permitType === "STD_PERMIT" ? pmt?.permit?.validStartDate : pmt?.permit?.tdate,
            fee: pmt?.permit?.fee,
            hasFulfillmentLetter: pmt?.permit?.hasFulfillmentLetter,
            lotName: pmt?.permit?.lotName,
            allowAnonymousSales: pmt?.permit?.allowAnonymousSales,
            id: pmt?.permit?.id,
            efpStartDate: pmt?.permit?.validStartDate,
          };
        });

        payObj = {
          userAccountId: id,
          groupName: user?.user?.userGroup,
          totalAmount: tAmount,
          fulfillmentAddressId: (checkoutSelectedAddress && checkoutSelectedAddress?.id) || (Array.isArray(address) && address[0]?.id),
          permitsToPurchase: permitData,
          confirmationEmailId: (checkoutSelectedEmail && checkoutSelectedEmail?.id) || (Array.isArray(email) && email[0]?.id),
          fulfillmentEmailId: (checkoutSelectedEmail && checkoutSelectedEmail?.id) || (Array.isArray(email) && email[0]?.id),
          paymentRequest: {
            cardDetails: {
              cvv: totalFeePrice[0] > 0 || totalFeePrice[1] > 0 ? encryptedCardInfo?.cvv : "",
              cardExpireMonth: totalFeePrice[0] > 0 || totalFeePrice[1] > 0 ? splitable[0] : "",
              cardExpireYear: totalFeePrice[0] > 0 || totalFeePrice[1] > 0 ? splitable[1] : "",
              billingAddress: {
                id: (checkoutSelectedBillingAddress && checkoutSelectedBillingAddress?.id) || (Array.isArray(address) && address[0]?.id),
                defaultFlag: (checkoutSelectedBillingAddress && checkoutSelectedBillingAddress?.defaultFlag) || (Array.isArray(address) && address[0]?.defaultFlag),
                line1: !shippingCheckbox ? (BillingAddress && BillingAddress?.values?.line1) : (checkoutSelectedAddress && checkoutSelectedAddress?.line1) || (Array.isArray(address) && address[0]?.line1),
                line2: !shippingCheckbox ? (BillingAddress && BillingAddress?.values?.line2) : (checkoutSelectedAddress && checkoutSelectedAddress?.line2) || (Array.isArray(address) && address[0]?.line2),
                city: !shippingCheckbox ? (BillingAddress && BillingAddress?.values?.city) : (checkoutSelectedAddress && checkoutSelectedAddress?.city) || (Array.isArray(address) && address[0]?.city),
                state: !shippingCheckbox ? userStates[0] : userState[0],
                zip: !shippingCheckbox ? (BillingAddress && BillingAddress?.values?.zip) : (checkoutSelectedAddress && checkoutSelectedAddress?.zip) || (Array.isArray(address) && address[0]?.zip),
                inactive: (checkoutSelectedBillingAddress && checkoutSelectedBillingAddress?.inactive) || (Array.isArray(address) && address[0]?.inactive),
              },
              cardNumber: totalFeePrice[0] > 0 || totalFeePrice[1] > 0 ? encryptedCardInfo?.cardNumber?.replace(/\s/g, "") : "",
              nameOnCard: totalFeePrice[0] > 0 || totalFeePrice[1] > 0 ? encryptedCardInfo?.cardHolderName : "",
            }, items: [{
              itemType: "PERMIT", price: 1,
            },],

            paymentMethod: {
              value: "ONLINE_CC", label: "Credit Card"
            }
          },
          taxAmount: tax,
        };
      }
    } else {
      permitData = permit?.map((pmt) => {
        return {
          allowAnonymousSales: pmt?.permit?.allowAnonymousSales,
          allowedNoVehicles: pmt?.permit?.allowedNoVehicles,
          fee: pmt?.permit?.fee,
          hasFulfillmentLetter: pmt?.permit?.hasFulfillmentLetter,
          id: pmt?.permit?.id,
          lotName: pmt?.permit?.lotName,
          name: pmt?.permit?.name,
          permitType: pmt?.permit?.permitType,
          price: pmt?.permit?.price,
          validEndDate: validSelectDatePayload(pmt?.permit?.tdate, pmt?.permit?.validDays, pmt, pmt?.permit?.validEndDate),
          validStartDate: pmt?.permit?.permitType === "STD_PERMIT" ? pmt?.permit?.validStartDate : pmt?.permit?.tdate,
          efpStartDate: pmt?.permit?.validStartDate,
          efpVisitReason: pmt?.reasonForVisit || "",
          vehicleIds: pmt?.vehicles?.map((vcl) => {
            return vcl.id;
          }),
        };
      });

      payObj = {
        groupName: user?.user?.userGroup,
        confirmationEmailId: (checkoutSelectedEmail && checkoutSelectedEmail?.id) || (Array.isArray(email) && email[0]?.id),
        fulfillmentAddressId: (checkoutSelectedAddress && checkoutSelectedAddress?.id) || (Array.isArray(address) && address[0]?.id),
        fulfillmentEmailId: (checkoutSelectedEmail && checkoutSelectedEmail?.id) || (Array.isArray(email) && email[0]?.id),
        paymentRequest: {
          acceptedAmount: tAmount, paymentMethod: paymentMethod,
        },
        permitsToPurchase: permitData,
        taxAmount: tax,
        totalAmount: tAmount,
        userAccountId: id,
      };
    }

    dispatch(getBuyPermitOrderPayment(payObj));
  };

  const handlePaymentMethod = (event) => {
    setPaymentMethod(event.target.value);
  };

  const BootstrapInput = withStyles((theme) => ({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
      },
    }, input: {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #ced4da",
      fontSize: 16,
      padding: "10px 26px 10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]), // Use the system font instead of the default Roboto font.
      fontFamily: ["-apple-system", "BlinkMacSystemFont", '"Segoe UI"', "Roboto", '"Helvetica Neue"', "Arial", "sans-serif", '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"',].join(","),
      "&:focus": {
        borderRadius: 4, borderColor: "#80bdff", boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  }))(InputBase);

  const handleCheckNo = (e) => {
    setCheckNo(e.target.value);
  };

  const renderPaymentInfo = () => {
    if (!paymentMethod) return null;

    if (paymentMethod === "ONLINE_CC" && paymentMethodList?.includes("ONLINE_CC")) {
      return (
        <div align="left" title="Payment Information">
          <Grid item xs={12} className="payment-box">
            <div className="titleField" style={{ marginBottom: '-16px' }}>
              <label htmlFor="creditcard">Enter Credit Card Number:</label>
            </div>
            <CreditCardText
              className="credit-card-img"
              name="credit"
              id="creditcard"
              value={state.credit || ""}
              onChange={handleChanges}
              autoComplete="cc-number"
            />
            {state.error && <div className="error">{state.error}</div>}
          </Grid>

          <Grid item xs={12} className={classes.spaceTop}>
            <div className="titleField">
              <label htmlFor="expiration">Expiration:</label>
            </div>
            <TextInputWithMasking
              name="expireDate"
              id="expiration"
              onChange={handleChange}
              placeHolder="MM/YY"
              mask="99/99"
              value={state.expireDate || ""}
              autoComplete="cc-exp"
            />
          </Grid>

          <Grid item xs={12} className={classes.spaceTop}>
            <div className="titleField">
              <label htmlFor="cvv">CVV Code:</label>
            </div>
            <TextInputWithMasking
              name="cvv"
              id="cvv"
              onChange={handleChange}
              placeHolder="3 or 4 Digit Security Code"
              mask="9999"
              value={state.cvv || ""}
              autoComplete="cc-csc"
            />
          </Grid>

          <Grid item xs={12} className={classes.spaceTop}>
            <div className="titleField">
              <label htmlFor="cardholderName">Cardholder Name:</label>
            </div>
            <TextInput
              name="cardHolderName"
              id="cardholderName"
              value={state.cardHolderName || ""}
              onChange={handleChange}
              autoComplete="cc-name"
            />
          </Grid>
        </div>
      )
    }

    if (paymentMethod === "CHECK") {
      return (
        <TextInput
          level="CHECK NO:"
          value={checkNo || ""}
          name="check_no"
          onChange={handleCheckNo}
        />
      );
    }
  };

  const getMask = (phNo) => {
    let x = phNo?.toString()?.split("");

    x?.splice(0, 0, "(");
    x?.splice(4, 0, ") ");
    x?.splice(8, 0, "-");
    let y = x?.join("");
    return y;
  };

  const getPaymentMethodName = (txt) => {
    switch (txt) {
      case "CASH":
        return "Cash";
      case "OTHER":
        return "Other";
      case "NO_CHARGE":
        return "No Charge";
      case "DRIVER_ACCOUNT":
        return "Student Account";
      case "CHECK":
        return "Check";
      case "PAYROLL_DEDUCTION":
        return "Payroll Deduction";
      case "PAYROLL_DEDUCTION_LUMP_SUM":
        return "Payroll Deduction - Lump Sum";
      case "PAYROLL_DEDUCTION_EACH_PAYCHECK":
        return "Payroll Deduction - Each Paycheck";
      case "ONLINE_CC":
        return "Credit Card"
      case 'TRANSACT_PAYMENTS':
        return 'Transact Payments';
      default:
        return txt;
    }
  };

  const handleBuyTermAndCondition = (e) => {
    setTermAndConditionsAccepted(e.target.checked);
    if (termAndConditionsAccepted === true) {
      dispatch(hideTermAndCondition());
    } else {
      dispatch(showTermAndCondition());
    }
  };

  const shouldDisableNextStep = () => {
    const isPaymentMethodUnselected = paymentMethod === '';
    const isOnlineCC = paymentMethod === 'ONLINE_CC';
    const feePrimary = totalFeePrice?.[0] || 0;
    const feeSecondary = totalFeePrice?.[1] || 0;
    const isUsingPlaceholderMerchant = merchantName === '0-Use for No Credit Card Account';

    // Step 0: Payment
    if (stepper.current === 0) {
      // Require a payment method if there's a fee and merchant is valid
      if (!isUsingPlaceholderMerchant || feePrimary === 0) {
        if (feePrimary > 0 && isPaymentMethodUnselected) {
          return true;
        }
        if (feePrimary > 0 || feeSecondary > 0) {
          if (isOnlineCC && !cardInfo) {
            return true;
          }
          return false; // Valid state
        }
        return false; // No fees
      }

      // Placeholder merchant logic
      if (feePrimary > 0 && isPaymentMethodUnselected) {
        return true;
      }
      return false;
    }

    // Step 1: Address info
    if (stepper.current === 1) {
      const isBillingMissing = BillingAddress?.length < 1;

      // Permit without charges (2 steps)
      if (feePrimary === 0 && feeSecondary === 0) {
        if (!termAndConditionsAccepted) return true
      }

      // Permit with charges (3 steps)
      return !shippingCheckbox && isBillingMissing && isOnlineCC;
    }

    // Permit with charges (3 steps)
    return !termAndConditionsAccepted;
  };

  const totalFeePrice = permit && permit.map((eleee) => eleee?.permit?.price + eleee?.permit?.fee);

  const shouldExcludeOnlineCC = merchantName === '0-Use for No Credit Card Account' || paymentProcessorType?.external

  const filteredPaymentMethodOptions = paymentMethodOptions
    .filter((item) => !shouldExcludeOnlineCC || item !== "ONLINE_CC")
    .filter((item) => !acceptedPaymentMethods.length || acceptedPaymentMethods.includes(item))
    .sort((a, b) => getPaymentMethodName(a).localeCompare(getPaymentMethodName(b)));

  return (
    <div>
      <h1 style={{ position: 'absolute', width: '1px', height: '1px', padding: 0, margin: '-1px', overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}>Checkout</h1>
      {submitOrder ? (
        <PermitPaymentStatus onPlaceAnotherOrder={goToAnotherPermit} />
      ) : (
        <div style={stylingVal && stylingVal} className={classes.root}>
          <div className={classes.toolbarContainer}>
            <div className={classes.innerFlex}>
              <Text
                style={{ fontWeight: "bold" }}
                color={props.StylingItem && props.StylingItem.bodyColor}
                variant="h3"
                className={classes.backgroundtheme}
              >
                Checkout
              </Text>
              <Divider />
            </div>
            <div className={`${classes.rightIconsContainer} ${classes.dflex}`}>
              <IconButton title="ShoppingCart">
                <Badge color="primary" badgeContent={permit?.length || 0}>
                  <ShoppingCart
                    className={classes.backgroundtheme}
                    onClick={(e) => goToCartModal}
                  />
                </Badge>
              </IconButton>
              <IconButton title="Cancel">
                <CancelRounded
                  className={classes.backgroundtheme}
                  onClick={cancelShowBuyPermitsExitOrderModal}
                />
              </IconButton>
            </div>
          </div>

          <Container maxWidth="xl">
            <div className="steptotalflex1">
              <Grid container spacing={2}>
                <Grid item xxl={7} xl={7} lg={7} md={8} sm={12} xs={12}>
                  {totalFeePrice[0] > 0 || totalFeePrice[1] > 0 ? (
                    // Permit with charges
                    <Stepper
                      activeStep={stepper.current}
                      orientation="vertical"
                      className={stepper.current === 1 ? "ww1001" : "123"}
                    >
                      <Step align="left" title="Payment Information">
                        <Text>Select Payment Method</Text>

                        <FormControl fullWidth style={{ marginBottom: 15 }}>
                          <InputLabel htmlFor="customized_select_payment_method" id="select_payment_method_label">Payment Method</InputLabel>
                          <Select
                            hidden
                            labelId="select_payment_method_label"
                            id="select_payment_method"
                            value={paymentMethod}
                            onChange={handlePaymentMethod}
                            displayEmpty
                            renderValue={(value) => (value ? getPaymentMethodName(value) : "Select Payment Method")}
                            input={<BootstrapInput id="customized_select_payment_method" />}
                          >
                            {filteredPaymentMethodOptions.map((payMethod) => (
                              <MenuItem key={payMethod} value={payMethod}>
                                {getPaymentMethodName(payMethod)}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>

                        {!shouldExcludeOnlineCC && renderPaymentInfo()}
                      </Step>


                      <Step align="left" title="Contact and Shipping Information">
                        {/* Shipping Address */}
                        <Grid item xs={12} className={classes.borderBottom}>
                          <Text><b>Shipping Address</b></Text>
                        </Grid>

                        <Grid item xs={12}>
                          <div className={classes.checkoutchangedflex}>
                            <Text style={{ fontWeight: 600, lineHeight: "20px" }}>
                              <div>{checkoutSelectedAddress?.line1 || address?.[0]?.line1}</div>
                              <div>{checkoutSelectedAddress?.line2 || address?.[0]?.line2}</div>
                              <div>
                                {checkoutSelectedAddress?.city || address?.[0]?.city}&nbsp;
                                {checkoutSelectedAddress?.state?.code || address?.[0]?.state?.code}&nbsp;
                                {checkoutSelectedAddress?.zip || address?.[0]?.zip}
                              </div>
                            </Text>
                            <Button
                              color="primary"
                              onClick={openSelectAddressModal}
                              className={classes.link}
                            >
                              Change
                            </Button>
                          </div>
                        </Grid>

                        {/* Billing Address Section for Online Payment */}
                        {paymentMethod === "ONLINE_CC" && (
                          <>
                            <Checkbox
                              style={{ paddingLeft: 0 }}
                              defaultChecked={shippingCheckbox}
                              onChange={() => setShippingCheckbox(!shippingCheckbox)}
                              color="primary"
                            />
                            <label>Billing Address is the Same as Shipping Address</label>

                            <Grid item xs={12} className={classes.borderBottom}>
                              <Text><b>Billing Address *</b></Text>
                            </Grid>

                            <Grid item xs={12}>
                              <div className={classes.checkoutchangedflex}>
                                <Text style={{ lineHeight: "20px" }}>
                                  {!shippingCheckbox ? (
                                    <>
                                      <div>{BillingAddress?.values?.line1}</div>
                                      <div>{BillingAddress?.values?.line2 || ""}</div>
                                      <div>
                                        {BillingAddress?.values?.city}&nbsp;
                                        {BillingAddress?.values?.state}&nbsp;
                                        {BillingAddress?.values?.zip}
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div>{checkoutSelectedAddress?.line1 || address?.[0]?.line1}</div>
                                      <div>{checkoutSelectedAddress?.line2 || ""}</div>
                                      <div>
                                        {checkoutSelectedAddress?.city || address?.[0]?.city}&nbsp;
                                        {checkoutSelectedAddress?.state?.code || address?.[0]?.state?.code}&nbsp;
                                        {checkoutSelectedAddress?.zip || address?.[0]?.zip}
                                      </div>
                                    </>
                                  )}
                                </Text>
                                <Button
                                  tabIndex="0"
                                  color="primary"
                                  onClick={openSelectBillingAddressModal}
                                  className={classes.link}
                                >
                                  Add Address
                                </Button>
                              </div>
                            </Grid>
                          </>
                        )}

                        {/* Email */}
                        <Grid item xs={12} className={classes.borderBottom}>
                          <Text><b>Email</b></Text>
                        </Grid>

                        <Grid item xs={12}>
                          <div className={classes.checkoutchangedflex}>
                            <Text>
                              <a
                                href={`mailto:${checkoutSelectedEmail?.address || email?.[0]?.address
                                  }`}
                              >
                                {checkoutSelectedEmail?.address || email?.[0]?.address}
                              </a>
                            </Text>
                            <Button
                              color="primary"
                              onClick={openSelectEmailModal}
                              className={classes.link}
                            >
                              Change
                            </Button>
                          </div>
                        </Grid>

                        {/* Phone */}
                        <Grid item xs={12} className={classes.borderBottom}>
                          <Text><b>Phone</b></Text>
                        </Grid>

                        <Grid item xs={12}>
                          <div className={classes.checkoutchangedflex}>
                            <Text>
                              {getMask(checkoutSelectedPhone?.number || phone?.[0]?.number)}
                            </Text>
                            <Button
                              color="primary"
                              onClick={openSelectPhoneModal}
                              className={classes.link}
                            >
                              Change
                            </Button>
                          </div>
                        </Grid>
                      </Step>

                      <Step align="left" className="align-padding" title="Review and Submit">
                        <Text><b>Billing Information</b></Text>
                        <Divider />

                        <Grid item xs={12}>
                          <div className={classes.checkoutchangedflex}>
                            <Text style={{ fontWeight: 600, lineHeight: "20px" }}>
                              {paymentMethod === "ONLINE_CC" && !shippingCheckbox ? (
                                <>
                                  <div>{BillingAddress?.values?.line1}</div>
                                  <div>{BillingAddress?.values?.line2}</div>
                                  <div>
                                    {BillingAddress?.values?.city}&nbsp;
                                    {BillingAddress?.values?.state}&nbsp;
                                    {BillingAddress?.values?.zip}
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div>{checkoutSelectedAddress?.line1 || address?.[0]?.line1}</div>
                                  <div>{checkoutSelectedAddress?.line2 || ""}</div>
                                  <div>
                                    {checkoutSelectedAddress?.city || address?.[0]?.city}&nbsp;
                                    {checkoutSelectedAddress?.state?.code || address?.[0]?.state?.code}&nbsp;
                                    {checkoutSelectedAddress?.zip || address?.[0]?.zip}
                                  </div>
                                </>
                              )}

                              <a href={`mailto:${checkoutSelectedEmail?.address || email?.[0]?.address}`}>
                                {checkoutSelectedEmail?.address || email?.[0]?.address}
                              </a>
                              <br />
                              {getMask(checkoutSelectedPhone?.number || phone?.[0]?.number)}
                              <br />
                            </Text>

                            <Button
                              color="primary"
                              onClick={shippingCheckbox ? handleBillingChange : openSelectAddressModal}
                              className={classes.link}
                            >
                              Change
                            </Button>
                          </div>
                        </Grid>

                        <Text><b>Payment Information</b></Text>
                        <Divider />

                        <Grid
                          container
                          item
                          xs={12}
                          justify="space-between"
                          style={{ alignItems: "center" }}
                          className={classes.spaceTop}
                        >
                          <Grid item>
                            {paymentMethod === "ONLINE_CC" && (
                              <img
                                src={VISA}
                                alt=""
                                className="payment-card"
                                style={{ display: "none" }}
                              />
                            )}
                          </Grid>
                          <Grid>
                            <Text color="primary">
                              {paymentMethod === "ONLINE_CC" && `Card Ending in ${state.credit?.slice(-5)}`}
                            </Text>
                            <Text color="primary">
                              {paymentMethod === "ONLINE_CC" && !shouldExcludeOnlineCC && `Expires ${state?.expireDate}`}
                            </Text>
                            <Text color="primary">
                              <strong>Total Amount :</strong> $
                              {(paymentMethod === "NO_CHARGE" ? 0 : grassTotal)?.toFixed(2)}
                            </Text>
                          </Grid>
                          <Grid>
                            <Button
                              color="primary"
                              onClick={handleCreditCardChange}
                              className={classes.link}
                            >
                              Change
                            </Button>
                          </Grid>
                        </Grid>

                        <Grid>
                          <Text><b>Permits Ordered (WITH CHARGES)</b></Text>
                          <Divider />

                          <div className="paymentOrder">
                            <Card style={{ position: "relative" }}>
                              <CardContent className="scrollable-cart" style={{ padding: 0 }}>
                                {permit?.map((row, index) => (
                                  <div className="d-flex contentwrapper" style={{ marginBottom: 5 }} key={index}>
                                    <div><PermitContent permit={row?.permit} /></div>
                                    <div className="text-left">
                                      <p className="headinText">{row?.permit?.name}</p>
                                      <p>
                                        Good from {moment(
                                          row?.permit?.permitType === "STD_PERMIT"
                                            ? row?.permit?.validStartDate
                                            : row?.permit?.tdate
                                        ).format("MM/DD/YYYY")} to{" "}
                                        {validSelectDate(
                                          row?.permit?.tdate,
                                          row?.permit?.validDays,
                                          row,
                                          row?.permit?.validEndDate
                                        )}
                                      </p>
                                      <p>
                                        Total Amount : $
                                        {(paymentMethod === "NO_CHARGE" ? 0 : grassTotal)?.toFixed(2)}
                                      </p>
                                      <div style={{ fontSize: "16px" }}>
                                        <table>
                                          {row?.vehicles?.map((item, i) => (
                                            <tr key={i}>
                                              <th>Vehicles {i + 1}</th>
                                              <td>
                                                {`${item?.year} ${item?.color} ${item?.model} ${item?.make?.name}`}{" "}
                                                {item?.licensePlate?.number} VIN {item?.vin}
                                              </td>
                                            </tr>
                                          ))}
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </CardContent>
                            </Card>

                            <MuiAlert severity="warning" style={{ marginTop: 16 }}>
                              Please DO NOT refresh or close this page until your order is complete.
                            </MuiAlert>

                            <div className={classes.checkoutTermandCondition}>
                              <p>
                                <label htmlFor="termsAndCondition">
                                  Please confirm your entries. Click Submit Order to place your order
                                  <br />
                                  <Checkbox
                                    checked={termAndConditionsAccepted}
                                    color="primary"
                                    onClick={handleBuyTermAndCondition}
                                    style={{ paddingBottom: "10px" }}
                                    id="termsAndCondition"
                                  />{" "}
                                  <span>By checking this box, you agree to the&nbsp;</span>
                                  <a
                                    style={{
                                      color: "#3f51b5",
                                      fontWeight: 600,
                                    }}
                                  >
                                    Terms and conditions
                                  </a>
                                </label>
                              </p>
                            </div>
                          </div>
                        </Grid>
                      </Step>
                    </Stepper>
                  ) : (
                    // Permit without charges
                    <Stepper
                      activeStep={stepper.current}
                      orientation="vertical"
                      className={stepper.current === 1 ? "ww1001" : "123"}
                    >
                      <Step align="left" title="Contact and Shipping Information">
                        {/* Shipping Address */}
                        <Grid item xs={12} className={classes.borderBottom}>
                          <Text>
                            <b>Shipping Address</b>
                          </Text>
                        </Grid>
                        <Grid item xs={12}>
                          <div className={classes.checkoutchangedflex}>
                            <p style={{ fontWeight: 600, lineHeight: "20px" }}>
                              <div>{checkoutSelectedAddress?.line1 || address?.[0]?.line1}</div>
                              <div>{checkoutSelectedAddress?.line2 || ""}</div>
                              <div>
                                {checkoutSelectedAddress?.city || address?.[0]?.city}&nbsp;
                                {checkoutSelectedAddress?.state?.code || address?.[0]?.state?.code}&nbsp;
                                {checkoutSelectedAddress?.zip || address?.[0]?.zip}
                              </div>
                            </p>
                            <Button
                              color="primary"
                              onClick={openSelectAddressModal}
                              className={classes.link}
                            >
                              Change
                            </Button>
                          </div>
                        </Grid>

                        {/* Email */}
                        <Grid item xs={12} className={classes.borderBottom}>
                          <Text>
                            <b>Email</b>
                          </Text>
                        </Grid>
                        <Grid item xs={12}>
                          <div className={classes.checkoutchangedflex}>
                            <Text className="ml_20">
                              <a
                                href={`mailto:${checkoutSelectedEmail?.address || email?.[0]?.address || ""
                                  }`}
                              >
                                {checkoutSelectedEmail?.address || email?.[0]?.address}
                              </a>
                            </Text>
                            <Button
                              color="primary"
                              onClick={openSelectEmailModal}
                              className={classes.link}
                            >
                              Change
                            </Button>
                          </div>
                        </Grid>

                        {/* Phone */}
                        <Grid item xs={12} className={classes.borderBottom}>
                          <Text>
                            <b>Phone</b>
                          </Text>
                        </Grid>
                        <Grid item xs={12}>
                          <div className={classes.checkoutchangedflex}>
                            <Text className="ml_20">
                              {getMask(
                                checkoutSelectedPhone?.number || phone?.[0]?.number || ""
                              )}
                            </Text>
                            <Button
                              color="primary"
                              onClick={openSelectPhoneModal}
                              className={classes.link}
                            >
                              Change
                            </Button>
                          </div>
                        </Grid>
                      </Step>

                      <Step align="left" className="align-padding" title="Review and Submit">
                        <Text>
                          <b>Billing Information</b>
                        </Text>
                        <Divider />
                        <Grid item xs={12}>
                          <div className={classes.checkoutchangedflex}>
                            <p className="fw-600" style={{ marginTop: 0, lineHeight: "20px" }}>
                              {BillingAddress?.length === 0 ? (
                                <>
                                  <div>{checkoutSelectedBillingAddress?.line1 || address?.[0]?.line1}</div>
                                  <div>{checkoutSelectedBillingAddress?.line2 || ""}</div>
                                  <div>
                                    {checkoutSelectedBillingAddress?.city || address?.[0]?.city}&nbsp;
                                    {checkoutSelectedBillingAddress?.state?.code || address?.[0]?.state?.code}&nbsp;
                                    {checkoutSelectedBillingAddress?.zip || address?.[0]?.zip}
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div>{BillingAddress?.values?.line1}</div>
                                  <div>{BillingAddress?.values?.line2}</div>
                                  <div>
                                    {BillingAddress?.values?.city}&nbsp;
                                    {BillingAddress?.values?.state}&nbsp;
                                    {BillingAddress?.values?.zip}
                                  </div>
                                </>
                              )}

                              <a
                                href={`mailto:${checkoutSelectedEmail?.address || email?.[0]?.address || ""
                                  }`}
                              >
                                {checkoutSelectedEmail?.address || email?.[0]?.address}
                              </a>
                              <br />
                              {getMask(checkoutSelectedPhone?.number || phone?.[0]?.number)}
                            </p>

                            <Text
                              color="primary"
                              onClick={openSelectAddressModal}
                              className={classes.link}
                              style={{ display: "none" }}
                            >
                              Change
                            </Text>
                          </div>
                        </Grid>

                        <Text>
                          <b>Payment Information</b>
                        </Text>
                        <Divider />
                        <Grid
                          container
                          item
                          xs={12}
                          justifyContent="space-between"
                          alignItems="center"
                          className={classes.spaceTop}
                        >
                          <Grid>
                            <Text color="primary" textAlign="center">
                              Total Amount: $
                              {paymentMethod === "NO_CHARGE" ? "0.00" : (grassTotal || 0).toFixed(2)}
                            </Text>
                          </Grid>
                          <Grid>
                            <Button
                              color="primary"
                              onClick={handleCreditCardChange}
                              className={classes.link}
                            >
                              Change
                            </Button>
                          </Grid>
                        </Grid>

                        <br />

                        <Grid>
                          <Text>
                            <b>Permits Ordered (NO CHARGES)</b>
                          </Text>
                          <Divider />
                          <div className="paymentOrder">
                            <Card style={{ position: "relative" }}>
                              <CardContent className="scrollable-cart" style={{ padding: 0 }}>
                                {Array.isArray(permit) &&
                                  permit.map((row, rowIndex) => {
                                    const { permit: permitData, vehicles } = row;
                                    const startDate = permitData?.permitType === "STD_PERMIT"
                                      ? permitData?.validStartDate
                                      : permitData?.tdate;

                                    return (
                                      <div key={rowIndex} className="d-flex contentwrapper" style={{ marginBottom: 5 }}>
                                        <div>
                                          <PermitContent permit={permitData} />
                                        </div>
                                        <div className="text-left">
                                          <p className="headinText">{permitData?.name}&nbsp;</p>
                                          <p>
                                            Good from {moment(startDate).format("MM/DD/YYYY")} to{" "}
                                            {validSelectDate(
                                              permitData?.tdate,
                                              permitData?.validDays,
                                              row,
                                              permitData?.validEndDate
                                            )}
                                          </p>
                                          <p>
                                            Total Amount : $
                                            {paymentMethod === "NO_CHARGE" ? "0.00" : (grassTotal || 0).toFixed(2)}
                                          </p>
                                          <div style={{ fontSize: "16px" }}>
                                            {Array.isArray(vehicles) && (
                                              <table>
                                                {vehicles.map((item, index) => (
                                                  <tr key={index}>
                                                    <th>Vehicle {index + 1}</th>
                                                    <td>
                                                      {`${item?.year} ${item?.color} ${item?.model} ${item?.make?.name}`}{" "}
                                                      {item?.licensePlate?.number} VIN {item?.vin}
                                                    </td>
                                                  </tr>
                                                ))}
                                              </table>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                              </CardContent>
                            </Card>

                            <div className={classes.checkoutTermandCondition}>
                              <p>
                                <label htmlFor="termsAndCondition">
                                  Please confirm your entries. Click Submit Order to place your order
                                  <br />
                                  <Checkbox
                                    checked={termAndConditionsAccepted}
                                    color="primary"
                                    onClick={handleBuyTermAndCondition}
                                    style={{ paddingBottom: "10px" }}
                                    id="termsAndCondition"
                                  />
                                  <span>By checking this box, you agree to the&nbsp;</span>
                                  <a
                                    href="#"
                                    style={{ color: "#3f51b5", fontWeight: "600" }}
                                  >
                                    Terms and conditions
                                  </a>
                                </label>
                              </p>
                            </div>
                          </div>
                        </Grid>
                      </Step>
                    </Stepper>
                  )}

                  <div className="" style={{ padding: "15px 0px" }}>
                    <StepperControlFooter
                      disabled={shouldDisableNextStep()}
                      submitText="Submit Order"
                      stepper={stepper}
                      onNext={handleNext()}
                      onCancel={cancelShowBuyPermitsExitOrderModal}
                      onBack={back}
                      onSubmit={(e) => handleSubmit(e, grassTotal)}
                    />
                  </div>
                </Grid>

                {/* Summary Section */}
                <Grid item xxl={5} xl={5} lg={5} md={4} sm={12} xs={12}>
                  <Card className="checkouttotal1">
                    <CardHeader className={classes.vehicleCardHeader} title="Summary" />

                    <div className={classes.summaryItems}>
                      {[
                        { label: "Permit Price", value: totalPrice },
                        { label: "Permit Fee", value: totalFee },
                        { label: "Tax", value: tax },
                        ...(creditCardConvenienceFee
                          ? [{
                            label: "Convenience Fee",
                            value: creditCardConvenienceFee,
                            info: "Additional fee applies",
                          }]
                          : []),
                      ].map(({ label, value, info }) => (
                        <div key={label} className={classes.summaryRow}>
                          <span className={classes.summaryLabel}>
                            {label}
                            {info && (
                              <Tooltip title={info} arrow>
                                <Info className={classes.summaryInfoIcon} />
                              </Tooltip>
                            )}
                          </span>
                          <span>${paymentMethod === "NO_CHARGE" ? "0.00" : (value || 0).toFixed(2)}</span>
                        </div>
                      ))}
                    </div>

                    <Divider />

                    <div className={classes.summaryTotalRow}>
                      <span>Total</span>
                      <span>${paymentMethod === "NO_CHARGE" ? "0.00" : (grassTotal || 0).toFixed(2)}</span>
                    </div>
                  </Card>

                  {stepper.current === 0 &&
                    PaymentPageEditorDataState?.trim() && (
                      <Card className={classes.checkoutinstruction}>
                        <div
                          className="ql-editor scroll_checkout"
                          style={{ color: "black" }}
                          dangerouslySetInnerHTML={{
                            __html: PaymentPageEditorDataState,
                          }}
                        />
                      </Card>
                    )}
                </Grid>
              </Grid>
            </div>
          </Container>
        </div>
      )}

      <BuyPerimtsEditOrderModal
        isOpenExitOrderModal={isOpenExitOrderModal}
        CancelBuyPermitsExitOrderModal={CancelBuyPermitsExitOrderModal}
        ConfirmBuyPermitsExitOrderModal={ConfirmBuyPermitsExitOrderModal}
      />
      <SelectAddressModal
        isOpenSelectAddressModal={isOpenSelectAddressModal}
        CloseSelectAddressModal={closeSelectAddressModal}
        handleOpenAddAddressModal={handleOpenAddAddressModal}
      />
      <AddAddressModal
        isOpenAddAddressModal={isOpenAddAddressModal}
        handleOpenAddAddressModal={handleOpenAddAddressModal}
        handleCloseAddAddressModal={handleCloseAddAddressModal}
      />
      <AddBillingAdressModal
        openBillingModal={openBillingModal}
        setOpenBillingModal={setOpenBillingModal}
      />
      <SelectPhoneModal
        isOpenSelectPhoneModal={isOpenSelectPhoneModal}
        CloseSelectPhoneModal={closeSelectPhoneModal}
        handleOpenAddPhoneModal={handleOpenAddPhoneModal}
      />
      <SelectEmailModal
        isOpenSelectEmailModal={isOpenSelectEmailModal}
        CloseSelectEmailModal={closeSelectEmailModal}
        handleOpenAddEmailModal={handleOpenAddEmailModal}
      />
      <AddPhoneNumberModal
        isOpenAddPhoneNumberModal={isOpenAddPhoneModal}
        handleOpenAddPhoneNumberModal={handleOpenAddPhoneModal}
        handleCloseAddPhoneNumberModal={handleCloseAddPhoneModal}
      />
      <AddEmailModal
        isOpenAddEmailModal={isOpenAddEmailModal}
        handleOpenAddEmailModal={handleOpenAddEmailModal}
        handleCloseAddEmailModal={handleCloseAddEmailModal}
      />
      <SelectBillingAddressModal
        isOpenSelectBillingAddressModal={isOpenSelectBillingAddressModal}
        CloseSelectBillingAddressModal={closeSelectBillingAddressModal}
        handleOpenAddBillingAddressModal={handleOpenAddAddressModal}
      />
      <SelectCreditCardInformationModal
        verifyModal={verifyModal}
        setVerifyModal={setVerifyModal}
      />
      <TermAndCondition />
    </div>
  );
};

export default CheckoutPermit;
